import PolygonSelector from "@/polygon/components/polygon-selector.tsx";

interface PolygonControlsProps {
  selectedPolygonIds: number[];
  onSelectionChange: (ids: number[]) => void;
  locationId?: number;
}

const PolygonControls = ({
  selectedPolygonIds,
  onSelectionChange,
  locationId,
}: PolygonControlsProps) => {
  return (
    <div className="flex flex-col gap-2">
        <div className={" w-60"}>
        <PolygonSelector
          onSelectionChange={onSelectionChange}
          selectedPolygonIds={selectedPolygonIds}
          locationId={locationId}
        />
        </div>
    </div>
  );
};

export default PolygonControls;
